<template>
  <div class="share-modal">
    <div class="update-timezone-wrapper">
      <a
        data-w-id="56ff7e67-4883-9846-e62a-00de9ffd5c11"
        @click="cancel"
        href="#"
        class="link-block-5 w-inline-block"
        ><img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt=""
      /></a>
      <div class="div-block-52">
        <h1 class="modal-heading">Share Post</h1>
      </div>
      <div class="w-layout-grid social-media-grid">
        <a href="#" class="social-media-wrapper w-inline-block"
          ><img
            src="@/assets/timeslot-images/twitter.svg"
            loading="lazy"
            alt=""
            class="social-media-icon"
          />
          <h5 class="social-media-name">Twitter</h5>
        </a>
        <a href="#" class="social-media-wrapper w-inline-block"
          ><img
            src="@/assets/timeslot-images/Facebook.svg"
            loading="lazy"
            alt=""
            class="social-media-icon"
          />
          <h5 class="social-media-name">Facebook</h5>
        </a>
        <a href="#" class="social-media-wrapper w-inline-block"
          ><img
            src="@/assets/timeslot-images/Discord.svg"
            loading="lazy"
            alt=""
            class="social-media-icon"
          />
          <h5 class="social-media-name">Discord</h5>
        </a>
        <a href="#" class="social-media-wrapper w-inline-block"
          ><img
            src="@/assets/timeslot-images/Whatsapp.svg"
            loading="lazy"
            alt=""
            class="social-media-icon"
          />
          <h5 class="social-media-name">Whatsapp</h5>
        </a>
        <a href="#" class="social-media-wrapper w-inline-block"
          ><img
            src="@/assets/timeslot-images/Telegram.svg"
            loading="lazy"
            alt=""
            class="social-media-icon"
          />
          <h5 class="social-media-name">Telegram</h5>
        </a>
        <a href="#" class="social-media-wrapper w-inline-block"
          ><img
            src="@/assets/timeslot-images/Messenger.svg"
            loading="lazy"
            alt=""
            class="social-media-icon"
          />
          <h5 class="social-media-name">Messenger</h5>
        </a>
      </div>
      <div class="copy-link-wrapper">
        <h4 class="h4">Copy Link</h4>
        <div class="link-field">
          <div class="text-block-45">https://www.rubies.ng/324554AB</div>
          <a href="#" class="w-inline-block"
            ><img src="@/assets/timeslot-images/Copy.svg" loading="lazy" alt=""
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareModal",
  props: {
    cancel: Function
  }
};
</script>

<style scoped></style>
